<section class="office-profile profiles-container">
  <div [jsonSchema]="[office.jsonLdSchema, productSchema]"></div>
  <app-loader [isLoading]="isLoading"></app-loader>
  <nav class="navigation is-flex has-flex-align-center hide-on-mobile">
    <app-back-button class="back-to "></app-back-button>
  </nav>
  <section class="flex-wrapper is-flex">
    <section class="primary-info wrapper">
      <app-profile-header preNameText="office-profile.brokerage" [name]="office.officeName" [description]="office.fullAddress"
        [latLng]="latLng">
        <div class="hide-on-mobile text-left" main>
          <app-detail-section [rows]="fastFactRowsDesktopOnly" [hideTitle]="true" sectionTitle="page-profile"></app-detail-section>
          <button class="btn btn-primary" (click)="openContactAgentOrOfficeForm(office)" translate="page-profile.ask-a-question"></button>
          <div class="secondary-info" *ngIf="office.hasSocialMedia">
            <app-connect-social-bar [name]="office.officeName" [web]="office.website"></app-connect-social-bar>
          </div>
        </div>
      </app-profile-header>
      <div class="contact-info hide-on-tablet-up">
        <a *ngIf="office.telephone" href="tel:{{office.telephone}}">
          <img src="{{'/assets/icons/page-profile/phone_icon.png' | staticp}}" alt="Cellphone" />{{ 'page-profile.phone' | translate }}</a>
        <a *ngIf="!office.telephone" class="disabled">
          <img src="{{'/assets/icons/page-profile/phone_icon.png' | staticp}}" alt="Cellphone" />{{ 'page-profile.phone' | translate }}</a>
        <a style="color: white;">|</a>
        <a (click)="openContactAgentOrOfficeForm(office)" [class.disabled]="!office.email">
          <img src="{{'/assets/icons/page-profile/email_icon.png' | staticp}}" alt="email" />{{ 'page-profile.email' | translate }}</a>
      </div>
      <div class="secondary-info hide-on-tablet-up">
        <hr class="hide-on-mobile full-width" />
        <app-detail-section class="hide-on-tablet-up" [rows]="fastFactRows" [hideTitle]="true"></app-detail-section>
        <button class="btn btn-primary full-width hide-on-tablet-up contact-btn" (click)="openContactAgentOrOfficeForm(office)" translate="page-profile.ask-a-question"></button>
        <app-connect-social-bar *ngIf="office.hasSocialMedia" [name]="office.officeName" [web]="office.website"></app-connect-social-bar>
      </div>
    </section>
    <app-ad-card class="ad" [ad]="ad"></app-ad-card>
  </section>
  <section class="office-listings listings wrapper has-pos-rel" *ngIf="officeListings.length">
    <h4 translate="office-profile.office-listings" [translateParams]="{count: listingsPagination.totalResults}"></h4>
    <app-item-swiper [items]="officeListings" [hasFinishedLoadingItems]="hasRetrievedSuggestedListings" (slideChanged)="onListingChanged($event)"
      [totalItems]="listingsPagination.totalResults"></app-item-swiper>
  </section>
  <section class="about wrapper">
    <h4 class="hide-on-tablet-up" style="margin-left: 10px;" translate="page-profile.about-us"></h4>
    <app-accordion #accordion class="hide-on-tablet-up">
      <app-accordion-item [index]="0" label="page-profile.areas-we-serve" [textOnly]="false">
        <b style="display: inline-block;">We serve:</b>
        <span *ngFor="let area of office.serviceAreas; let first = first; let last = last;">{{ last ? (first ? area : 'and ' + area) : area + ', '}}</span>.
      </app-accordion-item>
      <app-accordion-item [index]="1" label="page-profile.civic-activities" [textOnly]="false">
        <ul>
          <li *ngFor="let civic of office.civicActivities">{{civic}}</li>
        </ul>
      </app-accordion-item>
      <app-accordion-item [index]="2" label="page-profile.specialties" [textOnly]="false">
        <ng-container *ngFor="let x of specialitiesNumColumns; let index = index;">
          <ul>
            <li *ngFor="let specialties of office.specialties | slice:(index * maxNumberItemsPerList):(getListSize(index))">{{specialties}}</li>
          </ul>
        </ng-container>
      </app-accordion-item>
      <!-- <app-accordion-item [index]="3" label="office-profile.reviews" [textOnly]="false">
      </app-accordion-item> -->
    </app-accordion>
    <div class="hide-on-mobile">
      <h4 translate="page-profile.about" [translateParams]="{name: office.officeName}"></h4>
      <br>
      <b>
        <ng-container *ngIf="office.serviceAreas && office.serviceAreas.length">
          {{ 'page-profile.serving' | translate }}
          <span *ngFor="let area of office.serviceAreas; let first = first; let last = last;">{{ last ? (first ? area : 'and ' + area) : area + ', '}}</span>,
        </ng-container>
        <span translate="office-profile.specializes-in" [translateParams]="{name: office.officeName }"></span>
      </b>
      <div class="specialties list is-flex" *ngIf="office.specialties && office.specialties.length">
        <ng-container *ngFor="let x of specialitiesNumColumns; let index = index;">
          <ul>
            <li *ngFor="let specialties of office.specialties | slice:(index * maxNumberItemsPerList):(getListSize(index))">{{specialties}}</li>
          </ul>
        </ng-container>
      </div>
      <div class="civic-activities" *ngIf="office.civicActivities && office.civicActivities.length">
        <hr/>
        <b translate="page-profile.civic-activities"></b>
        <div class="list">
          <ul>
            <li *ngFor="let civic of office.civicActivities">{{civic}}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section #agentList class="agents wrapper" *ngIf="officeAgents && officeAgents.length">
    <h4 translate="office-profile.our-people" style="margin-bottom: 25px;"></h4>
    <app-agent-list [agents]="officeAgents" [pagination]="agentPagination" (onPaginationChange)="getAgents($event)" (onAgentEmailClicked)="openContactAgentOrOfficeForm($event)"></app-agent-list>
  </section>
  <div class="hide-on-tablet-up" #contactAgentMobile>
    <app-contact-agent [isFixed]="false" [contactForm]="contactForm" [leadInfo]="leadInfo" (requestSent)="showRequestSent = true"
      [listingCategory]="listingCategory" [locationType]="ContactFormLocationType.OFFICE_PAGE_CONTACT"></app-contact-agent>
  </div>



  <app-modal width="500" [shouldShowModal]="showContactForm" (closeModal)="showContactForm = false" [allowOutsideClickToClose]="false"
    [isFullHeight]="true" [templateRef]="contactAgentModalRef">
  </app-modal>
  <ng-template #contactAgentModalRef>
    <app-contact-agent [isFixed]="false" [contactForm]="contactForm" [leadInfo]="leadInfo" (requestSent)="showRequestSent = true; showContactForm = false;"
      [listingCategory]="listingCategory" [locationType]="ContactFormLocationType.OFFICE_PAGE_CONTACT"></app-contact-agent>
  </ng-template>
  <app-request-sent *ngIf="showRequestSent" (onClose)="showRequestSent = false" [nameToDisplay]="contactName"></app-request-sent>
</section>
